{
  "category_count": "2",
  "creep_dollars": "1,840",
  "display_name": "Andre",
  "household_name": "Andre's household",
  "income_growth_pct": "4.2",
  "spending_url": "https://dev.hearthfire.ai/spending#lifestyle-inflation",
  "summary": "• Restaurants: $4,820 this year vs $3,150 last year (+53.0%)\n• Travel: $9,400 this year vs $7,830 last year (+20.1%)",
  "threshold_pct": "9.2",
  "warn_pp": "5"
}
